import { Component, TemplateRef } from "@angular/core";
import { ToastService } from "src/app/core/services/toast.service";
import { CommonModule } from "@angular/common";
import { NgbToastModule } from "@ng-bootstrap/ng-bootstrap";
import { MatIconModule } from "@angular/material/icon";

@Component({
  selector: "app-error-toast",
  templateUrl: "./error-toast.component.html",
  styleUrls: ["./error-toast.component.scss"],
  host: { "[class.ngb-toasts]": "true" },
  imports: [CommonModule, NgbToastModule, MatIconModule],
})
export class ErrorToastComponent {
  constructor(public toastService: ToastService) {}

  isTemplate(toast) {
    return toast.textOrTpl instanceof TemplateRef;
  }
}
